var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterDesktopSingleShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M17.3 10a.7.7 0 0 1 .694.605L18 10.7v4.6a2.7 2.7 0 0 1-2.53 2.695L15.3 18H2.7a2.7 2.7 0 0 1-2.695-2.53L0 15.3v-4.6a.7.7 0 0 1 1.394-.095l.006.095v4.6a1.3 1.3 0 0 0 1.167 1.293l.133.007h12.6a1.3 1.3 0 0 0 1.293-1.167l.007-.133v-4.6a.7.7 0 0 1 .7-.7M9.2 0a.7.7 0 0 1 .408.131l.018.013a1 1 0 0 1 .06.052l.009.009 4.5 4.5a.7.7 0 0 1-.903 1.064l-.087-.074-3.306-3.306L9.9 11.7a.7.7 0 0 1-1.394.095L8.5 11.7l-.001-9.311-3.304 3.306a.7.7 0 0 1-.903.074l-.087-.074a.7.7 0 0 1-.074-.903l.074-.087 4.5-4.5.067-.06.013-.009-.08.069A.7.7 0 0 1 9.2 0"
})));
export default SvgTwitterDesktopSingleShare;